import React, { useState, useEffect } from "react";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
const fallbackSlides = [
  {
    id: "fallback-home-banner",
    Image: "https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/35d93c07-43a7-43d0-1d35-f042e1506900/w=900,sharpen=1",
    title: "Find Your Ideal Property",
    subtitle: "in Abu Dhabi",
    price: "",
    url: "/properties-for-sale",
  },
];
function CTA() {
    const [slides, setSlides] = useState(fallbackSlides);
      const [current, setCurrent] = useState(0);
      
  const API = process.env.REACT_APP_API_URL || "https://nvrealestate.ae";
   useEffect(() => {
    axios
      .get(`${API}/api/ctaimg.ashx`)
      .then((res) => {
        const result = Array.isArray(res.data?.data) ? res.data.data : [];
        setSlides(result.length ? result : fallbackSlides);
      })
      .catch((err) => {
        console.error("API error:", err);
        setSlides(fallbackSlides);
      });
  }, [API]);

  const [formData, setFormData] = useState({
    agent_name: "",
    agent_lname: "",
    agent_phone: "",
    agent_email: "",
    agent_address: ""
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");
  const [responseType, setResponseType] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((currentFormData) => ({
      ...currentFormData,
      [name]: value
    }));
    setErrors((currentErrors) => ({
      ...currentErrors,
      [name]: ""
    }));
  };

  const handlePhoneChange = (phone) => {
    setFormData((currentFormData) => ({
      ...currentFormData,
      agent_phone: phone
    }));
    setErrors((currentErrors) => ({
      ...currentErrors,
      agent_phone: ""
    }));
  };

  const validateForm = () => {
    const nextErrors = {};
    const phoneDigits = formData.agent_phone.replace(/\D/g, "");

    if (!formData.agent_name.trim()) nextErrors.agent_name = "First Name is required";
    if (!formData.agent_lname.trim()) nextErrors.agent_lname = "Last Name is required";
    if (!phoneDigits) {
      nextErrors.agent_phone = "Phone number is required";
    } else if (phoneDigits.length < 7 || phoneDigits.length > 15) {
      nextErrors.agent_phone = "Invalid phone number";
    }
    if (!formData.agent_email.trim()) {
      nextErrors.agent_email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.agent_email)) {
      nextErrors.agent_email = "Invalid email address";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const resetForm = () => {
    setFormData({
      agent_name: "",
      agent_lname: "",
      agent_phone: "",
      agent_email: "",
      agent_address: ""
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setResponseMsg("");
    setResponseType("");

    if (!validateForm()) return;

    setLoading(true);
    try {
      const payload = {
        proref: "Home: Professional Property Guidance",
        current_url: window.location.href,
        ...formData
      };
      const response = await axios.post(
        `${API}/api/EnquiryHandlerStatic.ashx`,
        JSON.stringify(payload),
        { headers: { "Content-Type": "application/json" } }
      );

      setResponseMsg(response.data?.message || "Message sent successfully!");
      setResponseType("success");
      resetForm();
      setErrors({});
    } catch (error) {
      setResponseMsg("Something went wrong. Please try again.");
      setResponseType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="footercta">
      <div className="top-footer property-guidance">
        <div className="container">
          <div className="property-guidance-card">
            <div className="property-guidance-content">
              <span className="property-guidance-label">Personal consultation</span>
              <h2>Get professional property guidance</h2>
              <p>
                Leave your details, and an advisor will help you choose the right
                property and navigate the purchase process.
              </p>
              <form className="contact-form" onSubmit={handleSubmit} noValidate>
                <div className="form-row">
                  <div className="ip-group">
                    <input
                      type="text"
                      name="agent_name"
                      value={formData.agent_name}
                      onChange={handleChange}
                      placeholder="First Name"
                      className={`form-control ${errors.agent_name ? "input-error" : ""}`}
                    />
                    {errors.agent_name && <p className="error-text">{errors.agent_name}</p>}
                  </div>
                  <div className="ip-group">
                    <input
                      type="text"
                      name="agent_lname"
                      value={formData.agent_lname}
                      onChange={handleChange}
                      placeholder="Last Name"
                      className={`form-control ${errors.agent_lname ? "input-error" : ""}`}
                    />
                    {errors.agent_lname && <p className="error-text">{errors.agent_lname}</p>}
                  </div>
                </div>

                <div className="form-row">
                  <div className="ip-group">
                    <PhoneInput
                      country="ae"
                      value={formData.agent_phone}
                      onChange={handlePhoneChange}
                      inputClass="form-control phone-input"
                      containerClass="phone-container"
                      enableSearch
                      placeholder="Enter phone number"
                    />
                    {errors.agent_phone && <p className="error-text">{errors.agent_phone}</p>}
                  </div>
                  <div className="ip-group">
                    <input
                      type="email"
                      name="agent_email"
                      value={formData.agent_email}
                      onChange={handleChange}
                      placeholder="Email"
                      className={`form-control ${errors.agent_email ? "input-error" : ""}`}
                    />
                    {errors.agent_email && <p className="error-text">{errors.agent_email}</p>}
                  </div>
                </div>

                <div className="ip-group">
                  <textarea
                    name="agent_address"
                    rows={4}
                    placeholder="Message"
                    value={formData.agent_address}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                {responseMsg && (
                  <div
                    className={responseType === "success" ? "success-text" : "error-text"}
                    role="status"
                  >
                    {responseMsg}
                  </div>
                )}

                <button
                  type="submit"
                  className="tf-btn-1 btn-view primary hover-btn-view w-100"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Get in touch"}
                </button>
              </form>

              <div className="social-wrapper">
                <div className="social-links">
                  <a href="https://www.instagram.com/nvrealestate_uae" target="_blank" rel="noreferrer" className="instagram">
                    <i className="fab fa-instagram" />
                  </a>
                  <a href="https://www.facebook.com/nvrealestate.uae" target="_blank" rel="noreferrer" className="facebook">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a href="https://www.linkedin.com/" target="_blank" rel="noreferrer" className="linkedin">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
 {slides.map((slide, index) => (
            <div className="property-guidance-advisor" key={slide.id || index}>
              <div className="property-guidance-photo">
                <img src={slide.Image} alt="Nova Vision property advisor" />
                <div className="property-guidance-badge">
                  <span>{slide.title}</span>
                  <strong>{slide.subtitle}</strong>
                </div>
              </div>
              <div className="property-guidance-quote">
                <span className="property-guidance-quote-mark">"</span>
                <p>
                  {slide.price}
                </p>
              </div>
              <a
                className="property-guidance-whatsapp"
                href={`https://wa.me/${slide.title || ""}`}
                target="_blank"
                rel="noreferrer"
              >
                <i className="fab fa-whatsapp" />
                Chat with us on WhatsApp
              </a>
            </div>
             ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTA;
